<template>
  <v-app id="subscription-expired">
    <v-main>
      <v-container class="fill-height" fluid :style="{ background: 'url(' + require('@/assets/bg.jpg') + ') center center / cover' }">
        <v-row align="center" justify="center">
          <v-overlay z-index="0" opacity="0.6" absolute></v-overlay>
          <!-- Ajustar el tamaño de la columna -->
          <v-col cols="12" sm="8" md="6" lg="4" style="z-index: 1">
            <v-card class="elevation-8 subscription-card">
              <v-card-title class="justify-center py-4">
                <div class="layout column align-center">
                  <!-- Ajustar tamaño del logo -->
                  <img src="@/assets/logo.png" alt="Logo" width="100" height="100" class="mb-3">
                  <h2 class="text-center red--text text--darken-1 text-h5 font-weight-bold">Suscripción no activa</h2>
                </div>
              </v-card-title>
              
              <v-card-text class="text-center pa-4">
                <!-- Ajustar tamaño del icono -->
                <v-icon color="red darken-1" size="56" class="mb-4">mdi-lock-alert</v-icon>
                
                <h3 class="text-h6 mb-4 font-weight-medium">No puede acceder al sistema</h3>
                
                <v-alert
                  dense
                  text
                  type="error"
                  class="mb-4 text-body-1"
                >
                  Su concesionario no tiene una suscripción activa. Para acceder, realice el pago correspondiente.
                </v-alert>
                
                <div class="text-body-1 mb-4">
                  Si ya realizó el pago, contacte con el administrador del sistema.
                </div>
              </v-card-text>
              
              <v-card-actions class="justify-center pa-4">
                <v-btn 
                  v-if="CURRENT_USER && CURRENT_USER.roles.includes('manager')"
                  color="primary"
                  @click="goToPayment"
                  class="px-4"
                >
                  <v-icon left>mdi-credit-card</v-icon>
                  Realizar pago
                </v-btn>
                
                <v-btn
                  text
                  color="grey darken-1"
                  @click="goToLogin"
                  class="ml-4"
                >
                  <v-icon left>mdi-logout</v-icon>
                  Cerrar sesión
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'SubscriptionExpired',
  
  methods: {
    goToPayment() {
      // Redirigir a la página de pago o contacto
      this.$router.push({ name: 'Payment' })
    },
    
    goToLogin() {
      // Cerrar sesión y redirigir al login
      this.$store.dispatch('LOGOUT').then(() => {
        this.$router.push({ name: 'Login' })
      })
    }
  },
  computed: {
    ...mapGetters(['CURRENT_USER'])
  }
}
</script>

<style scoped>
.subscription-card {
  border-radius: 8px;
  overflow: hidden;
  max-width: 480px;
  margin: 0 auto;
}

.v-card__title {
  padding-top: 20px;
  padding-bottom: 10px;
}

/* Ajustar el espaciado interno */
.v-card__text {
  padding: 16px 24px;
}

/* Ajustar altura de elementos para que sean más compactos pero legibles */
.v-alert {
  margin-bottom: 16px !important;
  line-height: 1.5;
}

/* Hacer que los textos se ajusten responsivamente */
.text-h5 {
  font-size: 1.4rem !important;
  line-height: 1.4;
}

.text-h6 {
  font-size: 1.15rem !important;
  line-height: 1.4;
}

.text-body-1 {
  font-size: 0.95rem !important;
  line-height: 1.5;
}

@media (max-width: 600px) {
  .subscription-card {
    max-width: 100%;
    margin: 0 16px;
  }
  
  .v-card__text {
    padding: 16px;
  }
  
  .v-card__actions {
    padding: 16px;
    flex-wrap: wrap;
  }
  
  .v-btn {
    margin: 4px !important;
  }
  
  /* Ajustar textos para móviles */
  .text-h5 {
    font-size: 1.25rem !important;
  }
  
  .text-h6 {
    font-size: 1.1rem !important;
  }
}

@media (min-width: 601px) and (max-width: 960px) {
  .subscription-card {
    max-width: 90%;
  }
}
</style>
